import React, { useState, useMemo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Box, useColorModeValue } from '@chakra-ui/react';

import { SidebarContext } from 'contexts/SidebarContext';

import routes from 'routes.js';

export default function Auth() {
  const [toggleSidebar, setToggleSidebar] = useState(false);

  const isFullScreenRoute = useMemo(
    () => window.location.pathname === '/auth/full-screen-maps',
    []
  );

  const authRoutes = useMemo(() => {
    const generateRoutes = (routes) =>
      routes.flatMap((route, key) =>
        route.layout === '/auth' ? (
          <Route path={route.path} element={route.component} key={key} />
        ) : route.collapse ? (
          generateRoutes(route.items)
        ) : null
      );
    return generateRoutes(routes);
  }, []);

  const authBg = useColorModeValue('white', 'navy.900');
  document.documentElement.dir = 'ltr';

  return (
    <Box>
      <SidebarContext.Provider value={{ toggleSidebar, setToggleSidebar }}>
        <Box
          bg={authBg}
          minHeight="100vh"
          position="relative"
          w="100%"
          transition="all 0.33s ease"
        >
          {!isFullScreenRoute && (
            <Box mx="auto" minH="100vh">
              <Routes>
                {authRoutes}
                <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
              </Routes>
            </Box>
          )}
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}